export default "__VITE_ASSET__BKOmgey4__"